import { render, staticRenderFns } from "./EndorsementContractGeneralProvisions.vue?vue&type=template&id=37c6a1c2"
import script from "./EndorsementContractGeneralProvisions.vue?vue&type=script&lang=js"
export * from "./EndorsementContractGeneralProvisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports